import { h, Component } from "preact";
import style from "./style";

export default class Solution extends Component {
  constructor() {
    super();
  }

  render() {
    let puzzle = this.props.puzzle;
    let fontStyle = { fontSize: 28 / this.props.columns + "vw" };

    return (
      <div>
        {puzzle.map((row, ri) => {
          return (
            <div style={fontStyle} class={style.solution__box}>
              {row.map((c, ci) => {
                if (c === "|") {
                  return (
                    <span class={style.box}>
                      <span class={style.oneVertical} />
                    </span>
                  );
                } else if (c === "$") {
                  return (
                    <span class={style.box}>
                      <span class={style.twoVertical} />
                    </span>
                  );
                } else if (c === "-") {
                  return (
                    <span class={style.box}>
                      <span class={style.oneHorizontal} />
                    </span>
                  );
                } else if (c === "=") {
                  return (
                    <span class={style.box}>
                      <span class={style.twoHorizontal} />
                    </span>
                  );
                } else if (c > 0 && c < 10) {
                  return (
                    <span class={style.box}>
                      <span class={style.number}>{c}</span>
                    </span>
                  );
                } else {
                  return (
                    <span class={style.box}>
                      <span />
                    </span>
                  );
                }
              })}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/solution/index.js